export default __webpack_public_path__ + "static/assets/overstockPattern.8021cf60.svg";